/** Two-letter avatar text: "Nikos Kofotolios" → NK, "admin" → AD, else the email's first two letters. */
export function initials(user: { name?: string; email?: string } | null): string {
  const words = (user?.name?.trim() || user?.email?.split("@")[0] || "").split(/[\s._-]+/).filter(Boolean);
  if (words.length >= 2) return ((words[0]?.[0] ?? "") + (words[1]?.[0] ?? "")).toUpperCase();
  return (words[0]?.slice(0, 2) || "?").toUpperCase();
}
